import { ProductPriceObj } from 'api/product/getPersonalizedProductDetails/types';
import cn from 'classnames';
import Radio from 'components/radio';
import { AnimatePresence, m } from 'framer-motion';
import useFilteredIntervalOptions from 'hooks/product/use-filtered-interval-options';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { gtm } from 'tracking';
import { Gtm } from 'tracking/gtm';
import { SubscriptionInterval } from '../../../../../../constants/order';
interface PropTypes {
  className?: string;
  couponPrices: ProductPriceObj | undefined;
  interval: SubscriptionInterval;
  isActive: boolean;
  onChange: (interval: SubscriptionInterval) => void;
  productId: number;
  /** Discount percentage for sub */
  subscriptionDiscount: number;
}

const SubscriptionIntervalForm: FC<PropTypes> = ({
  className,
  interval,
  isActive,
  productId,
  subscriptionDiscount,
  onChange,
}) => {
  const { filteredIntervalOptions } = useFilteredIntervalOptions({
    productIds: [productId],
  });

  return (
    <AnimatePresence>
      <p className="mt-1 text-xs text-text-secondary">
        {subscriptionDiscount ? (
          <FormattedMessage
            id="pdp:buy-panel:order-type:subscription:test-message"
            values={{
              discount: Number(subscriptionDiscount),
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        ) : (
          <FormattedMessage id="pdp:buy-panel:subscription-interval:sub-title" />
        )}
      </p>

      {isActive && (
        <m.div
          className={cn('', className)}
          key="interval-form"
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
          initial={{ opacity: 0, height: 0 }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className="mt-2">
            <div className="grid grid-cols-2 gap-1.5 pl-4">
              {filteredIntervalOptions.map((option) => (
                <div key={option.value} className="flex items-center py-1">
                  <Radio
                    name={'interval-radio'}
                    id={`${option.value}-radio`}
                    checked={interval === option.value}
                    value={option.value}
                    onChange={() => {
                      onChange(option.value);
                      gtm({
                        group: Gtm.GroupName.Subscription,
                        name: Gtm.SubscriptionEventName.IntervalSelect,
                        data: { label: option.value },
                      });
                    }}
                  >
                    <span className="ml-2">
                      <FormattedMessage id={option.translationKey} />
                    </span>
                  </Radio>
                </div>
              ))}
            </div>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default SubscriptionIntervalForm;
